// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useEffect, useMemo, useState } from 'react'
import './AccountSettingsPageTitle.scss'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { PrimaryButton } from 'ui_kit_qmd'
import { useDispatch, useSelector } from 'react-redux'
import { SecondaryButton } from '../../../components/ui_kit_quickMD/secondary-button/secondarybutton'
import { CANCEL_TEXT, SAVE_CHANGES_TEXT } from '../../../utils/constants'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { getProviderProfile } from '../../../store/waitingRoom/WaitingRoomThunk'
import { setIsEditSuccess } from '../../../store/accountSettings/AccountSettingsActions'
import { getTabId } from '../../../utils/common'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import usePageVisibility from '../../../utils/hooks/usePageVisibility'

const secondaryBtnContainerStyle = {
  height: 40,
  width: 200,
  border: '1px solid #00A2B2',
  padding: 0,
}
const primaryBtnContainerStyle = {
  height: 40,
  width: 200,
  marginLeft: 32,
}
const secondaryBtnLabelStyle = {
  fontSize: 20,
  fontWeight: 700,
  gap: 10,
  letterSpacing: 1.5,
}
const primaryBtnLabelStyle = {
  fontSize: 20,
  gap: 10,
  letterSpacing: 1.5,
}

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
const AccountSettingsPageTitle = memo(({ isEditMode, toggleIsEditMode, onCancelBtnClicked, onSafeBtnClicked }) => {
  const dispatch = useDispatch()
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const isEditSuccess = useSelector((state) => state.accountSettings.isEditSuccess)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const triggerTabId = useSelector((state) => state.accountSettings.triggerTabId)

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const tabs = useSelector((state) => state.accountSettings.tabs)
  const [pageTitle, setPageTitle] = useState('Account settings')
  const tabId = getTabId()

  useEffect(() => {
    if (isEditSuccess && tabId === triggerTabId) {
      toggleIsEditMode(false)
      dispatch(setIsEditSuccess(false))
    }
  }, [dispatch, isEditSuccess, toggleIsEditMode, tabId, triggerTabId])

  useEffect(() => {
    if (isEditMode) {
      if (tabs[0].isActive) {
        setPageTitle('Edit general information')
      }
      if (tabs[1].isActive) {
        setPageTitle('Edit password')
      }
    } else {
      setPageTitle('Account settings')
    }
  }, [isEditMode])

  const wrapperStyle = useMemo(() => ({ marginBottom: isEditMode ? 38 : 36 }), [isEditMode])

  return (
    <div className='settings-page-title-wrapper' style={wrapperStyle}>
      <div className='settings-page-title'>{pageTitle}</div>
      {isEditMode ?
        <div className='settings-edit-made-btn-block'>
          {/*
           // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
          <SecondaryButton
            id='viewServiceCancelEditBtn'
            btnText={CANCEL_TEXT}
            containerStyle={secondaryBtnContainerStyle}
            labelStyle={secondaryBtnLabelStyle}
            onPress={onCancelBtnClicked}
          />
          <PrimaryButton
            btnText={SAVE_CHANGES_TEXT}
            id='viewServiceSaveEditBtn'
            containerStyle={primaryBtnContainerStyle}
            labelStyle={primaryBtnLabelStyle}
            onPress={onSafeBtnClicked}
          />
        </div>
      : null}
    </div>
  )
})

export default AccountSettingsPageTitle
